import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useFormikContext } from 'formik';
import React from 'react'

export default function AppTextArea({ label, unedittable, name, placeholder, icon, disabled, rows }) {
  const {
    handleChange,
    errors,
    touched,
    setFieldTouched,
    values,
  } = useFormikContext();

  return (
    <div className="my-3 col-span-2">
      <label className={`block text-gray-800 text-sm mb-2 capitalize`} for={name}>
        {label || name}
      </label>
      <div className='flex w-full items-center shadow appearance-none border rounded-xl border-2 border-gray-400 w-full py-2 px-3 text-gray-700
                leading-tight '>
        <FontAwesomeIcon className='mr-2 text-fuchsia-900/80' size='lg' icon={icon} />
        <textarea
          disabled={disabled}
          name={name}
          onBlur={() => {
            setFieldTouched(name);
          }}
          placeholder={placeholder}
          value={values[name]}
          onChange={unedittable ? () => { } : handleChange}
          rows={rows || "2"} className='w-full focus:outline-none focus:shadow-outline'
        ></textarea>
      </div>
      {touched[name] && errors[name] && (
        <div className='text-red-400' style={{ fontSize: ".8rem" }}>{errors[name]}</div>
      )}
    </div>
  )
}
